import { next as next$1, nextInt as nextInt$1, nextBoolean as nextBoolean$1, nextRange as nextRange$1, nextIntBetween as nextIntBetween$1, shuffle as shuffle$1, randomWith as randomWith$1 } from '../../internal/defaultServices.esm.js';
import { RandomTypeId as RandomTypeId$1 } from '../../internal/random.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const RandomTypeId = RandomTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * Returns the next numeric value from the pseudo-random number generator.
 *
 * @since 2.0.0
 * @category constructors
 */
const next = next$1;

/**
 * Returns the next integer value from the pseudo-random number generator.
 *
 * @since 2.0.0
 * @category constructors
 */
const nextInt = nextInt$1;

/**
 * Returns the next boolean value from the pseudo-random number generator.
 *
 * @since 2.0.0
 * @category constructors
 */
const nextBoolean = nextBoolean$1;

/**
 * Returns the next numeric value in the specified range from the
 * pseudo-random number generator.
 *
 * @since 2.0.0
 * @category constructors
 */
const nextRange = nextRange$1;

/**
 * Returns the next integer value in the specified range from the
 * pseudo-random number generator.
 *
 * @since 2.0.0
 * @category constructors
 */
const nextIntBetween = nextIntBetween$1;

/**
 * Uses the pseudo-random number generator to shuffle the specified iterable.
 *
 * @since 2.0.0
 * @category constructors
 */
const shuffle = shuffle$1;

/**
 * Retreives the `Random` service from the context and uses it to run the
 * specified workflow.
 *
 * @since 2.0.0
 * @category constructors
 */
const randomWith = randomWith$1;

export { RandomTypeId, next, nextBoolean, nextInt, nextIntBetween, nextRange, randomWith, shuffle };
